import { DIFFICULTIES } from './problemFilters';
import { CountUp } from '../../ui/CountUp';
import { Skeleton } from '../../ui/Feedback';
import { useStrings } from '../../tenant/TenantProvider';

export function ProgressPanel({ problems, active, onSelect }) {
  const t = useStrings();

  if (!problems) {
    return (
      <section className="panel progress-panel" aria-busy="true">
        <div className="panel__body">
          <Skeleton width="40%" />
          <Skeleton width="100%" height={10} style={{ marginTop: 24 }} />
          <Skeleton width="100%" height={44} style={{ marginTop: 20 }} />
          <Skeleton width="100%" height={44} style={{ marginTop: 8 }} />
          <Skeleton width="100%" height={44} style={{ marginTop: 8 }} />
        </div>
      </section>
    );
  }

  const total = problems.length;
  const levels = DIFFICULTIES.map((level) => {
    const inLevel = problems.filter((problem) => problem.difficulty === level);
    return { level, key: level.toLowerCase(), total: inLevel.length, solved: inLevel.filter((problem) => problem.status === 'solved').length };
  });
  const solved = levels.reduce((sum, level) => sum + level.solved, 0);

  return (
    <section className="panel progress-panel lit" aria-labelledby="progress-title">
      <div className="panel__header">
        <h2 id="progress-title" className="panel__title">
          {t('problems.progress.title')}
        </h2>
        <span className="progress-panel__summary">
          <CountUp value={solved} className="progress-panel__solved" />
          <span className="muted">{t('problems.progress.ofTotal', { total })}</span>
        </span>
      </div>
      <div className="panel__body">
        <div
          className="progress-stack"
          role="img"
          aria-label={t('problems.solvedSummary', { solved, total })}
        >
          {levels.map(({ key, solved: count }) =>
            count > 0 ? <span key={key} className={`progress-stack__segment progress-stack__segment--${key}`} style={{ flexGrow: count }} /> : null
          )}
          {total - solved > 0 && <span className="progress-stack__rest" style={{ flexGrow: total - solved }} />}
        </div>
        <div className="progress-levels" role="group" aria-label={t('problems.difficultyFilter')}>
          {levels.map(({ level, key, total: levelTotal, solved: levelSolved }) => (
            <button
              key={level}
              type="button"
              className={`progress-level progress-level--${key}`}
              aria-pressed={active === level}
              onClick={() => onSelect(active === level ? 'all' : level)}
            >
              <span className="progress-level__name">{t(`difficulty.${level}`)}</span>
              <span className="progress-level__count tabular">
                <CountUp value={levelSolved} />
                <span className="subtle">/{levelTotal}</span>
              </span>
              <span className="progress-level__bar" aria-hidden="true">
                <span style={{ width: `${levelTotal ? (levelSolved / levelTotal) * 100 : 0}%` }} />
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
